import React from 'react';
import { CheckCircle } from 'lucide-react';
import { colors, spacing, typography } from '../../../../tokens';
import { Card } from '../../../../atoms';
import { formatTokenAmount } from '../utils/formatters';
import type { UserInfo } from '../constants';

interface UserSwapHistoryProps {
  userInfo: UserInfo | undefined;
}

export const UserSwapHistory: React.FC<UserSwapHistoryProps> = ({ userInfo }) => {
  if (!userInfo || !userInfo[0]) return null;

  return (
    <Card padding="lg" style={{ backgroundColor: colors.background.secondary.default }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: spacing.md,
          }}
        >
          <CheckCircle size={20} color={colors.brand.cyan.base} />
          <span
            style={{
              fontSize: typography.fontSize.base,
              color: colors.text.primary.default,
              fontWeight: typography.fontWeight.medium,
            }}
          >
            You have previously swapped
          </span>
        </div>
        <span
          style={{
            fontSize: typography.fontSize.lg,
            color: colors.brand.purple.base,
            fontWeight: typography.fontWeight.bold,
          }}
        >
          {formatTokenAmount(userInfo[1])} cFAR
        </span>
      </div>
    </Card>
  );
};
